export {
  handleSessionExpiration,
  isSessionTokenExpired,
  briefHttpError,
  getAuthHeaders,
} from "../../../../api/frameworksApi";

declare global {
  interface Window {
    BE_URL?: string;
    ENCRYPTION_SECRET?: string;
  }
}

export const BASE_URL = (window.BE_URL || "") + "/api/v1";

export interface ApiEnvelope<T> {
  status: string;
  apiVersion: string;
  requestId: string;
  timestamp: string;
  data: T;
  pagination: { page: number; pageSize: number; total: number } | null;
  errors: { code: string; message: string }[] | null;
}

export class ApiEnvelopeError extends Error {
  code: string;
  title: string;
  detail: string;
  pointer?: string;
  providerMessage?: string;
  status: number;

  constructor(args: {
    code: string;
    title: string;
    detail: string;
    pointer?: string;
    providerMessage?: string;
    status: number;
  }) {
    super(args.detail);
    this.name = args.title || "ApiEnvelopeError";
    this.code = args.code;
    this.title = args.title;
    this.detail = args.detail;
    this.pointer = args.pointer;
    this.providerMessage = args.providerMessage;
    this.status = args.status;
  }
}
